import { appsRoute } from 'App/Apps';
import { desktopsRoute } from 'App/Desktops';
import { homeRoute } from 'App/Home';
import { NativeWidgetRoute } from 'App/NativeWidget/NativeWidgetRoute';
import { LeftNavRoute } from 'Router/ReactRoute';
import { activityRoute } from './Activity';
import { customLinkBannerRoute } from './CustomLinkBanner';
import { searchRoute } from './Search';
import { settingsRoute } from './Settings';

export const appRoutes: LeftNavRoute[] = [
	homeRoute,
	NativeWidgetRoute,
	appsRoute,
	desktopsRoute,
	activityRoute,
	settingsRoute,
	searchRoute,
	customLinkBannerRoute,
];

export const horizontalAppRoutes: LeftNavRoute[] = [
	homeRoute,
	appsRoute,
	desktopsRoute,
	activityRoute,
	customLinkBannerRoute,
];
